<template>
  <div class="list-root rounded-2xl border border-theme-transparent px-3">
    <slot />
  </div>
</template>
